import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { SharedModule } from 'src/app/shared/shared.module';
import { VariantSizeSelectorComponent } from './variant-size-selector.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    I18nModule,
    MediaModule,
    MatTooltipModule,
    SharedModule,
    VariantSizeSelectorComponent,
  ],
  exports: [VariantSizeSelectorComponent],
})
export class VariantSizeSelectorModule {}
